import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { History } from 'history'

import {
  fetchUser,
  updateUser,
  disableUser,
  suspendFraudulentUser,
} from './userActions'
import { selectUser } from '../../reducers/users'
import UserProfileEditForm from './userProfileEditForm'
import { BadgeGate } from '../common/permissions/badgeGate'
import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  disableUser: Callback
  fetchUser: Callback
  history: History
  match: Match<ParamsID>
  suspendFraudulentUser: Callback
  updateUser: Callback<Promise<any>>
  user: User
}

export class UserProfileEdit extends Component<Props> {
  componentWillMount() {
    const { fetchUser, match } = this.props
    if (match?.params?.id) {
      fetchUser(match.params.id)
    }
  }

  onSubmit = (values) => {
    const { history, updateUser } = this.props
    const { birthday } = values
    let formattedValues = null
    if (birthday) {
      const birthdayBits = birthday.split('/')
      const robotBirthday = `${birthdayBits[2]}-${birthdayBits[0]}-${birthdayBits[1]}`
      formattedValues = Object.assign({}, values, { birthday: robotBirthday })
    }

    return updateUser(formattedValues || values).then(() => {
      history.goBack()
    })
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  disableUserOnClick = (id) => {
    const { disableUser, user } = this.props
    if (
      user.enabled === true &&
      window.confirm('Are you sure you want to disable this user?')
    ) {
      disableUser(id)
      this.backToIndex()
    } else if (user.enabled === false) {
      window.alert('User is already disabled')
    }
  }

  suspendFraudulentUserOnClick = (id) => {
    const { suspendFraudulentUser, user } = this.props
    if (
      !user.fraud &&
      window.confirm('Are you sure you want to mark the user as fraudulent?')
    ) {
      suspendFraudulentUser(id)
      this.backToIndex()
    } else if (user.fraud) {
      window.alert('User is already marked as fraudulent')
    }
  }

  render() {
    const { user } = this.props

    if (!user) {
      return null
    }

    const {
      id,
      firstName,
      lastName,
      birthday,
      phone,
      activationState,
      enabled,
    } = user

    const initialValues = {
      id,
      firstName,
      lastName,
      birthday,
      phone,
      activationState,
    }

    return (
      <Fragment>
        <div className="user-profile-edit">
          {user.id && (
            <UserProfileEditForm
              onSubmit={this.onSubmit}
              initialValues={initialValues}
              // userId={id} // TODO-TS
              cancel={this.backToIndex}
            />
          )}
        </div>
        <div className="user-profile-edit-disable">
          <BadgeGate
            disableUI
            requiredBadges={['CAN_DISABLE_USERS']}
          >
            <button
              data-testid="user-profile-edit-disable-button"
              onClick={() => this.disableUserOnClick(user.id)}
              className="button button--primary user-profile-edit__form__button--submit"
              disabled={!enabled}
              type="button"
            >
              Disable User
            </button>
          </BadgeGate>
        </div>
        <div className="user-profile-edit-fraud">
          <BadgeGate
            disableUI
            requiredBadges={['USERS', 'EDIT_USER', 'SUSPEND_USER']}
          >
            <button
              data-testid="user-profile-edit-suspend-button"
              onClick={() => this.suspendFraudulentUserOnClick(user.id)}
              className="button button--primary user-profile-edit__form__button--submit"
              disabled={!enabled}
              type="button"
            >
              Mark as Fradulent
            </button>
          </BadgeGate>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  user: selectUser(state.users, match.params.id),
})

export const mapDispatchToProps = (dispatch) => ({
  fetchUser: (id) => dispatch(fetchUser(id)),
  updateUser: (values) => dispatch(updateUser(values)),
  disableUser: (id) => dispatch(disableUser(id)),
  suspendFraudulentUser: (id) => dispatch(suspendFraudulentUser(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileEdit)
